import React from "react";
import {
  FaChartPie,
  FaCoins,
  FaCubes,
  FaFileContract,
  FaLightbulb,
} from "react-icons/fa";

function CardanoDApp() {
  return (
    <>
      <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">What we do</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Xeer’s Cardano Blockchain Development Services
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className=" fade-up-anim ">
            <div className="row">
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <div className="icon">
                      <FaCubes size={40} />
                    </div>
                    <h4>
                      <a>Cardano DApp Development</a>
                    </h4>
                    <p>
                      We develop decentralized applications on Cardano, ensuring
                      security, scalability, and a user-friendly experience that
                      is adaptable to multiple industries.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <div className="icon">
                      <FaFileContract size={40} />
                    </div>
                    <h4>
                      <a>Smart Contract Development</a>
                    </h4>
                    <p>
                      Our experts create robust smart contracts using Plutus and
                      Marlowe, Cardano’s smart contract programming languages,
                      to deliver transparent and reliable automation for your
                      business.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <div className="icon">
                      <FaChartPie size={40} />
                    </div>
                    <h4>
                      <a>Cardano DeFi Solutions</a>
                    </h4>
                    <p>
                      Xeer’s Cardano DeFi services include decentralized
                      exchanges (DEX), lending platforms, and staking solutions
                      that tap into the strengths of the Cardano blockchain.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="brand-style-two-items">
                <div className="col-lg-4 col-md-6 process-two-single pt-4">
                  <div className="services-style-two-item">
                    <div className="top-info">
                      <div className="icon">
                        <FaCoins size={40} />
                      </div>
                      <h4>
                        <a>Token Development (ADA, Native Tokens)</a>
                      </h4>
                      <p>
                        We facilitate the creation of ADA-based tokens and
                        native assets on Cardano, providing options for
                        tokenized applications and fungible/non-fungible tokens
                        (NFTs).
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 process-two-single pt-4">
                  <div className="services-style-two-item fade-up-anim">
                    <div className="top-info">
                      <div className="icon">
                        <FaLightbulb size={40} />
                      </div>
                      <h4>
                        <a>Blockchain Consulting</a>
                      </h4>
                      <p>
                        Our team offers consulting to guide you through
                        Cardano’s ecosystem, ensuring you make strategic
                        decisions for development, integration, and
                        optimization.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CardanoDApp;
